import React from 'react';
import { Mail, Linkedin, ArrowRight, Sparkles, CalendarDays } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-24 bg-[#0d1321] text-white px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-106" data-mp="2za4mm3grgub8">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-107" data-mp="2pjs1a914gx41">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-cyan-500 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse" data-id="element-108" data-mp="3d8b96ng9f7vl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-109" data-mp="3i633fo4dn62y"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-cyan-400 rounded-full mix-blend-multiply filter blur-3xl opacity-5 animate-pulse" style={{
        animationDelay: '2s'
      }} data-id="element-110" data-mp="38b2r0mv433uc"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative" data-id="element-111" data-mp="7o93wir8zewo">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-cyan-500/20 rounded-2xl mb-6 backdrop-blur-sm border border-cyan-400/30 glow-cyan" data-id="element-112" data-mp="2od7b4kvqpr5">
          <Sparkles className="h-8 w-8 text-cyan-400" data-id="element-113" data-mp="clhk4dsu58va" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-white to-cyan-200 bg-clip-text text-transparent" data-id="element-114" data-mp="cnc4nr072yyu">
          Get in Touch
        </h2>
        <p className="text-xl text-slate-400 mb-12 max-w-2xl mx-auto" data-id="element-115" data-mp="ll4p19krwwt3">
          Interested in discussing the future of financial infrastructure,
          post-quantum security, or potential collaborations?
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-116" data-mp="vcir9p440apx">
          <a href="https://www.linkedin.com/in/arthur-miller-64b32165/" target="_blank" rel="noopener noreferrer" className="group flex items-center gap-3 px-8 py-4 bg-cyan-500 hover:bg-cyan-400 text-black rounded-xl font-bold transition-all w-full sm:w-auto justify-center shadow-lg hover:shadow-xl hover:scale-105 transform duration-200 glow-cyan" data-id="element-117" data-mp="19c1nbjjnbvlv">
            <Linkedin className="h-5 w-5 group-hover:scale-110 transition-transform" data-id="element-118" data-mp="aye83ivq93mx" />
            Connect on LinkedIn
            <ArrowRight className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-119" data-mp="fs8oodg1d2hs" />
          </a>

          <a href="https://calendly.com/arthur-w-miller/30min" target="_blank" rel="noopener noreferrer" className="group flex items-center gap-3 px-8 py-4 bg-white/5 hover:bg-white/10 text-white rounded-xl font-medium transition-all w-full sm:w-auto justify-center border border-white/20 hover:border-cyan-500/40 backdrop-blur-sm hover:scale-105 transform duration-200" data-id="element-120" data-mp="pobsroug7b7d">
            <CalendarDays className="h-5 w-5 text-cyan-400 group-hover:scale-110 transition-transform" data-id="element-121" data-mp="30hocczjykb37" />
            Schedule a Meeting
            <ArrowRight className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-122" data-mp="2sz70imom0k72" />
          </a>
        </div>

        {/* Additional info cards */}
        <div className="grid md:grid-cols-3 gap-6 mt-16 mb-16" data-id="element-123" data-mp="2j8cbxbnw58ig">
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10" data-id="element-124" data-mp="2f5z8itwm9mou">
            <div className="text-cyan-400 font-bold text-lg mb-2" data-id="element-125" data-mp="3bvzrgcab18y8">Location</div>
            <div className="text-slate-300" data-id="element-126" data-mp="3btvphzvyuk0l">Arizona, United States</div>
          </div>
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10" data-id="element-127" data-mp="36xoi02nx90gj">
            <div className="text-cyan-400 font-bold text-lg mb-2" data-id="element-128" data-mp="32tgto6ldlmiu">Role</div>
            <div className="text-slate-300" data-id="element-129" data-mp="2xv5mk3mgtq4b">Founder & CEO, FiQIS</div>
          </div>
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10" data-id="element-130" data-mp="1rgenm5gwkfcx">
            <div className="text-cyan-400 font-bold text-lg mb-2" data-id="element-131" data-mp="1mgsb5y8wf356">
              Expertise
            </div>
            <div className="text-slate-300" data-id="element-132" data-mp="3acorz1rt3d9p">Financial Infrastructure</div>
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-white/10 text-slate-500 text-sm flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-133" data-mp="3f5hudizsy9im">
          <p data-id="element-134" data-mp="31b8eum9lwx1s">
            &copy; {new Date().getFullYear()} Arthur Miller. All rights
            reserved.
          </p>
          <p data-id="element-135" data-mp="3t4hau3d5vi3p">Founder & CEO, FiQIS</p>
        </div>
      </div>
    </section>;
}